import { useState, useEffect } from 'react';

const cache = new Map();
const MAX_CACHE = 100;
const FRESH_TTL = 30000; // 30 seconds — skip re-fetch if data is this fresh

export function useCache(key, fetchFn) {
  const [data, setData] = useState(cache.get(key)?.data ?? null);
  const [loading, setLoading] = useState(!cache.has(key));

  useEffect(() => {
    if (!key) return;
    const cached = cache.get(key);
    if (cached) {
      setData(cached.data);
      setLoading(false);
      // Skip background refresh if data is fresh
      if (Date.now() - cached.ts < FRESH_TTL) return;
    } else {
      setLoading(true);
    }
    let cancelled = false;
    fetchFn()
      .then(result => {
        if (cancelled) return;
        if (cache.size >= MAX_CACHE) {
          cache.delete(cache.keys().next().value);
        }
        cache.set(key, { data: result, ts: Date.now() });
        setData(result);
      })
      .catch(() => {})
      .finally(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
  }, [key]);

  return { data, loading };
}
